import { ApiEnvironment } from '../../models/api-environment';

export class AuditLogEnvironment extends ApiEnvironment {
  auditlogSearchUrl(partnerId: string) {
    return `${this.baseUrl}/api/auditlog/search/${partnerId}`;
  }

  override resolve(environment: unknown) {
    return environment instanceof AuditLogEnvironment ? environment : this;
  }
}

export const auditLogEnvironment = new AuditLogEnvironment();
